<template>
    <div class="no-data">
        <inline-svg src="/assets/img/icons/file-heart-circle.svg"></inline-svg>
        <div class="no-data-title mt-4 mb-1">No Card Decks yet</div>
        <div class="no-data-subtitle mb-4">
            {{ subtitle ? subtitle : 'You can create a Card Deck or use some from the Community Library.'}}
        </div>
        <div class="d-flex gap-1">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "NoCardDecks",
    props: ['subtitle']
}
</script>

<style scoped>

</style>
